import * as React from "react";
const SvgConvertCard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#convertCard_svg__a)">
      <path
        stroke="#89909D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
        d="M12 6.202h8.996M3.005 16.547H12m8.996-1.853a6.29 6.29 0 0 1-6.297 6.297l.945-1.574M3.004 9.297A6.29 6.29 0 0 1 9.303 3l-.945 1.574M13.997 3H19c1.601 0 1.997.396 1.997 1.979v3.697c0 1.583-.396 1.98-1.997 1.98h-5.002c-1.6 0-1.997-.397-1.997-1.98V4.98C12 3.396 12.396 3 13.997 3M5.002 13.345h5.001c1.602 0 1.997.396 1.997 1.979v3.697C12 20.604 11.605 21 10.003 21H5.002c-1.601 0-1.997-.396-1.997-1.979v-3.697c0-1.583.396-1.98 1.997-1.98"
      />
    </g>
    <defs>
      <clipPath id="convertCard_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgConvertCard;
